import api from '@/api'

const state = {
}

const mutations = {
}

const actions = {
  // 获取存储挂载列表
  async getStorageList ({commit, state}, payload) {
    const {data} = await api.deployApi.getStorageList(payload)
    return data
  },
  // 新增存储挂载
  async addStorage ({commit, state}, payload) {
    const {code, message} = await api.deployApi.addStorage(payload)
    return {code, message}
  },
  // 编辑存储挂载
  async editStorage ({commit, state}, payload) {
    const {code, message} = await api.deployApi.editStorage(payload)
    return {code, message}
  },
  // 删除存储挂载
  async deleteStorage ({commit, state}, payload) {
    const {data} = await api.deployApi.deleteStorage(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
